import svg4everybody from 'svg4everybody';
import whenDomReady from 'when-dom-ready';
function initialise() {
    svg4everybody();
}
whenDomReady().then(initialise);
